import React from 'react';
import { Banner as BannerComponent } from '~/components/Admin';

export function Banner() {
    return <BannerComponent />;
}
